import React from 'react'
import { ICommentApi } from 'src/service/api/api.types'
import Form from 'src/components/Curso/Classroom/Comments/Form'
import CardComment from 'src/components/Curso/Classroom/Comments/Card'
import { BoxComment, BoxCommentChildren } from 'src/components/Curso/Classroom/Comments/styles'

interface Props {
  comments: ICommentApi[]
}

const Comments: React.FC<Props> = props => {
  function renderChild(item: ICommentApi) {
    if (item.children && item.children.length > 0) {
      return (
        <BoxCommentChildren>
          {item.children.map(comment => (
            <div key={comment.id}>
              <CardComment comment={comment} idFather={item.id} hasResponse />
            </div>
          ))}
        </BoxCommentChildren>
      )
    }
    return null
  }

  return (
    <div>
      <Form hasCardComment={false} />
      {props.comments ?
        props.comments.map(item => (
          <BoxComment key={item.id}>
            <CardComment comment={item} hasResponse={false} idFather={item.id} />
            {renderChild(item)}
          </BoxComment>
        )) : null}
    </div>
  )
}

export default Comments
